import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {FormDropDownList, DropDownList} from 'components/controls';
import {usStates, getStateByAbbreviation} from 'sources/constants/states';

export default class StatesDropDownList extends Component {
    static propTypes = {
        value: PropTypes.any,
        onChange: PropTypes.func,
        fieldKey: PropTypes.string.isRequired,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        emptyValuePlaceholder: PropTypes.string,
        allValueLabel: PropTypes.string,
        isFormElement: PropTypes.bool
    };

    static defaultProps = {
        label: loc('license-label'),
        placeholder: loc('license-placeholder'),
        fieldKey: 'licenses',
        emptyValuePlaceholder: loc('choose'),
        allValueLabel: loc('choose')
    };

    constructor(props) {
        super(props);
        this.items = usStates.map(state => state.abbreviation);
    }

    render() {
        return this.props.isFormElement ? this.renderFormElement() : this.renderPlainElement();
    }

    renderPlainElement() {
        const {placeholder, value, onChange, fieldKey, emptyValuePlaceholder, ...dropDownProps} = this.props;

        return (
            <DropDownList fieldKey={fieldKey}
                          placeholder={placeholder}
                          items={this.items}
                          formatter={::this.formatLicenses}
                          multipleFormatter={values => {
                              return values.length === 0
                                  ? emptyValuePlaceholder
                                  : `${values.length} ${values.length === 1 ? 'license' : 'licences'}`
                          }}
                          value={value}
                          onChange={onChange}
                          multipleSelection
                          canBeNotSelected
                          searchable
                          {...dropDownProps}
            />
        );
    }

    renderFormElement() {
        const {label, placeholder, value, onChange, fieldKey, emptyValuePlaceholder, ...dropDownProps} = this.props;

        return (
            <FormDropDownList fieldKey={fieldKey}
                              label={label}
                              placeholder={placeholder}
                              items={this.items}
                              formatter={::this.formatLicenses}
                              multipleFormatter={values => {
                                  return values.length === 0
                                      ? emptyValuePlaceholder
                                      : `${values.length} ${values.length === 1 ? 'license' : 'license(s)'}`
                              }}
                              value={value}
                              onChange={onChange}
                              multipleSelection
                              canBeNotSelected
                              searchable
                              {...dropDownProps}
            />
        );
    }

    formatLicenses = (value, {head}) => {
        const {emptyValuePlaceholder, allValueLabel} = this.props;
        if (!value && head)
            return emptyValuePlaceholder;

        if (!value)
            return allValueLabel;

        return getStateByAbbreviation(value);
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/StatesDropDownList.js